import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Organization, Product, QualityPermissions, User } from '@app/models';
import {
  N8nChatService,
  N8nChatState,
  OrganizationService,
  ProductService,
  ToastService,
  UserService,
} from '@app/services';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { VersionService } from 'app/_services/version.service';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { NgxPermissionsService } from 'ngx-permissions';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { ThemeService } from 'app/_services/theme.service';
import { environment } from '../../../environments/environment';
import { fadeInTop } from '../../_helpers/animations/fade.animations';
import { SwitchProductsOrganizations } from '../evo-switch/evo-switch.component';
import { HelpDialogComponent } from '../help-dialog/help-dialog.component';

@Component({
  selector: 'app-fixed-top-header',
  templateUrl: './fixed-top-header.component.html',
  styleUrls: ['./fixed-top-header.component.scss'],
  animations: [fadeInTop],
})
export class FixedTopHeaderComponent implements OnInit, OnDestroy {
  @Input() currentUser: User;
  modalRef: BsModalRef;

  changePassword = false;

  public products: Product[] = [];
  public organizations: Organization[] = [];

  public isInternal: boolean = false;

  public switchProductsOrganizations: SwitchProductsOrganizations;

  public showSwitch = false;
  public showSpeed = false;

  public homepage: string = environment.features.homepage;

  public showAdminBtn: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(
    false
  );

  public showSupport: boolean = environment.features.enableSupport;
  public showFaq: boolean = environment.features.enableFaq;
  public enableDarkMode: boolean = environment.features.enableDarkMode;

  public n8nChatState: N8nChatState | null = null;
  public hasN8nPendingRequest: boolean = false;
  private subscriptions: Subscription[] = [];

  public currentTheme$: Observable<'light' | 'dark'>;

  public get idUrl(): string {
    return environment.apps['id'];
  }

  constructor(
    public userService: UserService,
    public organizationService: OrganizationService,
    public productService: ProductService,
    public ngxPermissionsService: NgxPermissionsService,
    public modalService: NgbModal,
    private versionService: VersionService,
    private toastService: ToastService,
    private n8nChatService: N8nChatService,
    private router: Router,
    public themeService: ThemeService
  ) {
    this.currentTheme$ = this.themeService.getTheme$();
  }

  ngOnInit() {
    this.organizationService
      .findAll()
      .pipe(
        switchMap(value => {
          this.organizations = value.filter(item => item.status == 'ACTIVE');
          return this.productService.findAll();
        })
      )
      .subscribe(data => {
        this.switchProductsOrganizations = new SwitchProductsOrganizations();
        this.switchProductsOrganizations.allProducts = data as any;
        this.switchProductsOrganizations.allOrganizations = this.organizations;
      });

    this.userHasInternal();
    this.checkAdminPermission();
    this.initializeN8nSubscription();
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  private initializeN8nSubscription(): void {
    if (environment.features.n8nEnabled) {
      const n8nSub = this.n8nChatService.chatState.subscribe(state => {
        this.n8nChatState = state;
        this.hasN8nPendingRequest = state.isPending;
      });
      this.subscriptions.push(n8nSub);
    }
  }

  public checkAdminPermission(): void {
    let hasAdminPermission = false;

    this.userService.currentUser.organizations.some(org => {
      this.showAdminBtn.next(org.admin);

      return org.admin;
    });

    if (
      this.showAdminBtn.value ||
      !this.userService.currentUser.roles ||
      this.userService.currentUser.roles.length == 0
    ) {
      return;
    }

    this.userService.currentUser.roles.some(role => {
      let adminPermission = role.permissions.filter(
        permission => permission.product == 'ADMIN'
      );

      if (adminPermission.length > 0) {
        hasAdminPermission = true;
        this.showAdminBtn.next(true);
      }

      return hasAdminPermission;
    });
  }

  public get qualityPermissions(): typeof QualityPermissions {
    return QualityPermissions;
  }

  logout() {
    this.userService.logout();
  }

  myProfile() {
    this.router.navigate(['/myProfile']);
  }

  public goToOrganizationList(): void {
    localStorage.removeItem('organizationId');
    this.router.navigate(['/organizations']);
  }

  /*organizations() {
        this.router.navigate(['/organizations']);
    }*/

  public openHelpDialog(): void {
    const modalRef = this.modalService.open(HelpDialogComponent, {});

    modalRef.result.then(data => {
      if (data) {
      }
    });
  }

  public userHasInternal(): void {
    this.ngxPermissionsService
      .hasPermission(QualityPermissions.INTERNAL)
      .then(data => {
        this.isInternal = data;
      });
  }

  public checkForUpdates(): void {
    this.versionService.getVersion().subscribe(data => {
      if (data && data.version != this.versionService.config.version) {
        this.versionService.newVersionAvailable = true;
        this.versionService.newVersion = data.version;
      }

      if (data && data.version == this.versionService.config.version) {
        this.toastService.showSuccess(
          'Você está usando a versão mais recente.'
        );
      }
    });
  }

  public toggleTheme(): void {
    this.themeService.toggleTheme();
  }
}
